import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as myGlobals from '../app.component';

@Injectable({
  providedIn: 'root',
})
export class JarwisService {
  
  private baseUrl = myGlobals.baseUrl;

  constructor(private http: HttpClient) { }

  register(data) {
    return this.http.post(`${this.baseUrl}/register`, data);
  }

  login(data) {
    // return this.http.post<any>(`${this.baseUrl}/login`, data, {observe: 'response'});
    
    // return this.http.request('post', `${this.baseUrl}/login`, {
    //       body: data,
    //       responseType: 'json',
    //       observe: 'response',
    //       withCredentials: true
    //   });
    // .subscribe(resp => {
    //   console.log(resp.headers.get('X-Token'));
    // });

    return this.http.post(`${this.baseUrl}/login`, data);
  }

  logout(data) {
    return this.http.post(`${this.baseUrl}/logout`, data);
  }

  sendPasswordResetLink(data) {
    return this.http.post(`${this.baseUrl}/forgetpassword`, data);
  }

  resetpassword(data) {
    return this.http.post(`${this.baseUrl}/resetpassword`, data);
  }

  resetExpiredPassword(data) {
    return this.http.post(`${this.baseUrl}/resetExpiredPassword`, data);
  }

  emailVerification(data) {
    return this.http.post(`${this.baseUrl}/emailVerification`, data);
  }

  getUserData(data) {
    return this.http.post(`${this.baseUrl}/getUserData`, data);
  }

  studentRegister(data){
    return this.http.post(`${this.baseUrl}/studentRegister`, data);
  }

  checkRightClickPermission(){
    return this.http.get(`${this.baseUrl}/checkRightClickPermission`);
  }

  createSalt(data){
    return this.http.post(`${this.baseUrl}/createSalt`, data);
  }

  getOTP(data) {
    return this.http.post(`${this.baseUrl}/getOTP`, data);
  }

  generatePassword(data) {
    return this.http.post(`${this.baseUrl}/generatePassword`, data);
  }
}
